import { createAsyncThunk } from "@reduxjs/toolkit";
import { attivita, attivitaAdd, attivitaDelete,} from "./attivita.api";
import { logout } from "../../auth/auth.slice";

export const addAttivita = createAsyncThunk(
    'features/addAttivita',
    async (infoAttivita, { getState, rejectWithValue }) => {
        const stato = getState();
        const response = await attivitaAdd(stato.auth.user.token, infoAttivita);
        if (response.esito === 1) {
            return response;
        }
        else if(response.esito === 0 && response.errorCode === 2)
        {
            return rejectWithValue('Attivita gia esistente');
        }
        else {
            return rejectWithValue(response.error);
        }
    }
)

export const getAttivita = createAsyncThunk(
    'features/attivita',
    async (pagina, { getState, rejectWithValue, dispatch }) => {

        const stato = getState();
        const response = await attivita(stato.auth.user.token, pagina);

        if (response.esito === 1) {
            return response;
        }
        else {
            if(response.code === 401)
            {
                dispatch(logout());
            }
            return rejectWithValue(response.error);
        }
    }
)

export const deleteAttivita = createAsyncThunk(
    'features/deleteAttivita',
    async (id, { getState, rejectWithValue }) => {
        const stato = getState();
        const response = await attivitaDelete(stato.auth.user.token, id);
        if (response.esito === 1) {
            return response;
        }
        else if (response.esito === 2) {
            return rejectWithValue("Impossibile eliminare un Attivita");
        }
        else {
            return rejectWithValue(response.error);
        }
    }
)
